import Vue from "vue";
import Vuex from "vuex";
import { uuid } from "./utils";
import services from "./services/services";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    list: [],
    loggedIn: false,
    loginFail: false,
    idToken: null,
    userId: null,
  },
  mutations: {
    authUser(state, userData) {
      state.idToken = userData.idToken;
      state.userId = userData.userId;
    },
    CREATE_ITEM(state, { list, name }) {
      list.push({
        name,
        id: uuid(),
        description: "",
      });
    },
    DELETE_ITEM(state, itemId) {
      for (let i = 0; i < state.list.length; i++) {
        if (state.list[i].id === itemId) {
          state.list.splice(i, 1);
          return;
        }
      }
    },
    CLEAR_LIST(state) {
      state.list = [];
    },
    FETCH_LIST(state) {
      services
        .getList(state.idToken)
        .then((response) => {
          if (!response.data) {
            state.list = [];
            return;
          }

          state.list = response.data;
        })
        .catch((error) => {
          console.log("Error fetching list: ", error);
        });
    },
    UPDATE_LIST(state, list) {
      state.list = list;
    },
    STORE_LIST(state, list) {
      services
        .putList(list, state.idToken)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log("Error updating list: ", error);
        });
    },
    UPDATE_ITEM(state, { item, key, value }) {
      item[key] = value;
    },
  },
  actions: {
    login({ commit, state }, authData) {
      axios
        .post(
          "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyD7o_VQ_YlFj6Uxn1iiQYcKk4RAzmz1300",
          {
            email: authData.email,
            password: authData.password,
            returnSecureToken: true,
          }
        )
        .then((res) => {
          commit("authUser", {
            idToken: res.data.idToken,
            userId: res.data.localId,
          });

          state.loggedIn = true;
          state.loginFail = false;
          localStorage.setItem(
            "authData",
            JSON.stringify({
              idToken: state.idToken,
              userId: state.userId,
              refreshToken: res.data.refreshToken,
            })
          );

          const now = new Date();
          const expirationDate = new Date(
            now.getTime() + res.data.expiresIn * 1000
          );
          localStorage.setItem("authExpiration", expirationDate);
        })
        .catch((err) => {
          console.log(err);
          state.loginFail = true;
        });
    },
    refreshExpiredToken({ commit, state }, refreshToken) {
      axios
        .post(
          "https://securetoken.googleapis.com/v1/token?key=AIzaSyD7o_VQ_YlFj6Uxn1iiQYcKk4RAzmz1300",
          {
            grant_type: "refresh_token",
            refresh_token: refreshToken,
          }
        )
        .then((res) => {
          commit("authUser", {
            idToken: res.data.id_token,
            userId: res.data.user_id,
          });

          state.loggedIn = true;
          state.loginFail = false;
          localStorage.setItem(
            "authData",
            JSON.stringify({
              idToken: state.idToken,
              userId: state.userId,
              refreshToken: res.data.refresh_token,
            })
          );

          const now = new Date();
          const expirationDate = new Date(
            now.getTime() + res.data.expires_in * 1000
          );
          localStorage.setItem("authExpiration", expirationDate);
        })
        .catch((err) => console.log(err));
    },
  },
  getters: {
    getItem(state) {
      return (id) => {
        for (const item of state.list) {
          if (item.id == id) {
            return item;
          }
        }
      };
    },
    listLength(state) {
      return state.list.length;
    },
  },
});
